module.exports = __webpack_public_path__ + "static/media/Workshop_Bitcoin.4c828707.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Workshop_Bitcoin.png
// module id = 22
// module chunks = 0